import Activity from './model';

export default Activity;



// WEBPACK FOOTER //
// ./data/CoveredInClass/Activity/index.js